<template>
  <div class="card has-width-500 has-padding-30">
    <div>
      <h4 class="has-padding-10 is-size-4">Update User - <span class="is-size-4 has-text-weight-bold	">{{user_details.full_name}}</span></h4>
    </div>
    <div>
      <form action method="POST" @submit.prevent="updateUser">
        <validation-observer
          ref="adminNewUserObserver"
          tag="div"
          v-slot="{invalid, valid, untouched, errors}"
        >
          <div class="columns flex-column has-margin-top-20">
            <!-- Name of user -->
            <div class="column is-12">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Update Full Name'"
                rules="required"
                v-model="full_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Username of user -->
            <div class="column is-12">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Update Username'"
                rules="required"
                v-model="user_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Email of user -->
            <div class="column is-12">
              <input-with-validation
                :name="'email'"
                :errorLabel="'email'"
                :label="'Update Email Address'"
                rules="required|email"
                v-model="email"
                :type="'text'"
                :vid="'email'"
              ></input-with-validation>
            </div>

            <!-- Submit Button -->
            <div class="column is-12">
              <button
                class="button is-primary is-full-width has-margin-bottom-20"
                :class="{'is-loading': loading, 'is-disabled': loading}"
              >
                <span>Update User</span>
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>


<script>
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("admin");
import UpdateUserMutation from "../api/graphql/mutations/UpdateUserMutations";
import { async } from "q";
import { mapGetters as mapRootGetters } from "vuex";

export default {
  name: "admin-update-user",
  components: {
    InputWithValidation,
    ValidationObserver,
    Multiselect
  },
  props: {
      user_details: {type: Object, required: true}
  },
  data() {
    return {
      full_name: this.user_details.full_name,
      user_name: this.user_details.user_name,
      email: this.user_details.email,
      port_id: null,
      user_type: null,
      current_user: null,
      loading: false,
      nimasaAdminUser: [
        { id: 1, value: "NIMASA_USER", label: "NIMASA AGENT" },
        { id: 2, value: "NIMASA_MANAGER", label: "NIMASA MANAGER" }
      ],
      hudsontridentUser: [
        { id: 1, value: "PORT_USER", label: "Port User" },
        { id: 1, value: "NIMASA_ADMIN", label: "NIMASA Admin User" }
      ]
    };
  },

  mounted() {
    /**
     * Get the right user
     */
    if (this.isNimasaAdmin) {
      this.current_user = "nimasaAdmin";
    }

    if (this.isHudsontridentUser) {
      this.current_user = "hudsontridentAdmin";
    }

    /**
     * Get the ports
     */

    if (!this.ports) {
      this.ports = this.getPorts.data;
    }
  },
  computed: {
    ...mapGetters({
      isNimasaAdmin: "isNimasaAdmin",
      isHudsontridentUser: "isHudsontridentUser"
    }),
    ...mapRootGetters({
      getPorts: "getPorts"
    }),
    updateUser() {
    
      if (this.user_details.role === "Port User") {
        return this.updatePortUser;
      }
      if (this.user_details.role === "NIMASA Admin User") {
        return this.updateNimasaAdminUser;
      }
      if (this.user_details.role === "NIMASA Agent" || "NIMASA Manager") {
        return this.updateNimasaUser;
      }
    }
  },
  methods: {

    /**
     * Update Port User
     */
    updatePortUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }

      this.loading = true;

      this.$apollo
        .mutate({
          mutation: UpdateUserMutation.PortUserMutation,
          variables: {
            full_name: this.full_name,
            email: this.email,
            user_name: this.user_name,
            id: this.user_details.id
          }
        })
        .then(response => {
          const port_user_name = response.data.UpdatePortUser.name;
          this.$toast.open({
            duration: 6000,
            message: `The Port User details have been updated successfully`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not update user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Update NIMASA Admin User
     */
    updateNimasaAdminUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }

      this.loading = true;

      this.$apollo
        .mutate({
          mutation: UpdateUserMutation.NimasaAdminUserMutation,
          variables: {
            full_name: this.full_name,
            email: this.email,
            user_name: this.user_name,
            id: this.user_details.id
          }
        })
        .then(response => {
          const admin_user_name = response.data.UpdateNimasaAdminUser.name;
          this.$toast.open({
            duration: 8000,
            message: `${admin_user_name.toUpperCase()} has been updated successfully.`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not update user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * Update NIMASA User.
     */

    updateNimasaUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: UpdateUserMutation.NimasaUserMutation,
          variables: {
            full_name: this.full_name,
            email: this.email,
            user_name: this.user_name,
            id: this.user_details.id
          }
        })
        .then(response => {
          const nimasa_user_name = response.data.UpdateNimasaUser.name;
          this.$toast.open({
            duration: 8000,
            message: `User ${nimasa_user_name.toUpperCase()} has been updated successfully.`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not update user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateUserPortID(option) {
      this.port_id = +option.id;
    }
  }
};
</script>